/**
 * Shared helpers for building chat navigation paths that respect project
 * context.
 *
 * When a chat session (existing or newly created) is associated with a
 * project, links should route through the nested
 * `/projects/:projectUuid/chat[...]` path rather than the flat `/chat` path,
 * so the project context bar and sidebar active-state stay consistent no
 * matter where the navigation originated from.
 */

/** Base route paths used throughout the app navigation. */
export const ROUTES = {
  CHAT: "/chat",
  PROJECTS: "/projects",
  AGENTS: "/agents",
  DATA_SOURCES: "/data-sources",
} as const;

/** Path for an existing chat session, nested under its project if it has one. */
export function buildChatSessionPath(sessionUuid: string, projectUuid?: string | null): string {
  return projectUuid
    ? `${ROUTES.PROJECTS}/${projectUuid}${ROUTES.CHAT}/${sessionUuid}`
    : `${ROUTES.CHAT}/${sessionUuid}`;
}

/** Path for starting a fresh chat, nested under a project if one is active. */
export function buildNewChatPath(projectUuid?: string | null): string {
  return projectUuid ? `${ROUTES.PROJECTS}/${projectUuid}${ROUTES.CHAT}` : ROUTES.CHAT;
}
